import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_layout/my-classes/')({
  loader: () => {
    throw redirect({
      to: '/my-classes/calendar',
    });
  },
});
